import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useStytch } from '@stytch/react';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { toggleAdmin } from '../../../../store/chat/slice';
import { selectIsAdmin } from '../../../../store/user/slice';
import { Button } from '../../../UI';
import { Text } from '../../../Typography';
import styles from './UserSettingsContent.module.scss';

interface UserSettingsContentProps {
  onClose: () => void;
}

const UserSettingsContent: React.FC<UserSettingsContentProps> = ({ onClose }) => {
  const navigate = useNavigate();
  const stytch = useStytch();
  const user = stytch.user.getSync();
  const dispatch = useAppDispatch();
  const isAdmin = useAppSelector(selectIsAdmin);
  const { isAdminOpen } = useAppSelector((state) => state.chat);

  const handleLogout = async () => {
    try {
      await stytch.session.revoke();
      navigate('/login');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  const toggleAdminPanel = () => {
    dispatch(toggleAdmin());
    onClose();
  };

  const userEmail = user?.emails?.[0]?.email;

  return (
    <div className={styles.userPopover}>
      <div className={styles.userInfo}>
        <Text size="small" color="neutral-500" element="span">
          Signed in as
        </Text>
        <Text weight="medium" color="neutral-700" element="span">
          {userEmail}
        </Text>
      </div>

      {isAdmin && (
        <div className={styles.adminToggle}>
          <Button variant="ghost" size="small" fullWidth onClick={toggleAdminPanel}>
            {isAdminOpen ? 'Hide Admin Panel' : 'Show Admin Panel'}
          </Button>
        </div>
      )}

      <Button variant="ghost" size="small" fullWidth onClick={handleLogout}>
        Sign out
      </Button>
    </div>
  );
};

export default UserSettingsContent;
